import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import Nav from "@/components/Nav";
import { toast } from "sonner";

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    api.get("/orders").then(r => setOrders(r.data)).finally(()=>setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const reorder = async (id) => {
    try {
      const { data } = await api.post(`/orders/${id}/reorder`);
      toast.success("Reordered successfully");
      load();
    } catch { toast.error("Reorder failed"); }
  };

  return (
    <div className="min-h-screen bg-[var(--pf-bg)]">
      <Nav />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-10">
        <div className="pf-label mb-3">Section · Orders</div>
        <h1 className="text-5xl font-black tracking-tighter mb-10">All orders.</h1>
        {loading ? <div className="pf-label">Loading…</div> : orders.length === 0 ? (
          <div className="border border-dashed border-[var(--pf-border)] p-16 text-center text-[var(--pf-text-2)]" data-testid="no-orders">
            No orders yet.
          </div>
        ) : (
          <div className="border border-[var(--pf-border)]">
            <div className="grid grid-cols-12 gap-4 p-4 border-b border-[var(--pf-border)] pf-label bg-white">
              <div className="col-span-3">Order</div>
              <div className="col-span-2">Product</div>
              <div className="col-span-2">Qty</div>
              <div className="col-span-2">Total</div>
              <div className="col-span-2">Status</div>
              <div className="col-span-1"></div>
            </div>
            {orders.map(o => (
              <div key={o.id} className="grid grid-cols-12 gap-4 p-4 border-b last:border-0 border-[var(--pf-border)] items-center hover:bg-white" data-testid={`order-row-${o.id}`}>
                <div className="col-span-3">
                  <Link to={`/orders/${o.id}`} className="font-mono text-xs text-[var(--pf-text-2)] hover:text-[var(--pf-brand)]">#{o.id.slice(0,8).toUpperCase()}</Link>
                  <div className="font-mono text-xs mt-1">{new Date(o.created_at).toLocaleDateString()}</div>
                </div>
                <div className="col-span-2 capitalize">{o.product_type.replace('_',' ')}</div>
                <div className="col-span-2 font-mono">{o.quantity.toLocaleString()}</div>
                <div className="col-span-2 font-mono font-semibold">₹{o.total_amount.toLocaleString()}</div>
                <div className="col-span-2">
                  <span className="text-[10px] uppercase tracking-widest font-bold px-2 py-1 bg-[var(--pf-surface-2)]">{o.status.replace('_',' ')}</span>
                </div>
                <div className="col-span-1 text-right">
                  <button onClick={()=>reorder(o.id)} data-testid={`reorder-${o.id}`} className="text-xs font-bold uppercase tracking-wider hover:text-[var(--pf-brand)]">Reorder</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
